export default "__VITE_ASSET__DefZXd9w__"